"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDropDirection = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const getDropDirection_1 = tslib_1.__importDefault(require("./getDropDirection"));
const useDropDirection = ({ pullRight = false, dropup = false, autoDropDirection = false, dropdownMenuRef }, dependencies) => {
    // Note: Using an object for local state has lead to tests getting stuck here.
    // The solution was to split the values into dedicated state primitives here.
    const [internalPullRight, setInternalPullRight] = (0, react_1.useState)(pullRight);
    const [internalDropup, setInternalDropup] = (0, react_1.useState)(dropup);
    const isAutoDropActive = () => !(!autoDropDirection || dropup || pullRight);
    // Overwrite position of dropdown menu in case auto drop is enabled
    (0, react_1.useEffect)(() => {
        if (dropdownMenuRef.current && isAutoDropActive()) {
            const result = (0, getDropDirection_1.default)(dropdownMenuRef.current.parentNode, dropdownMenuRef.current);
            setInternalPullRight(result.pullRight);
            setInternalDropup(result.dropup);
        }
    }, [...dependencies, dropdownMenuRef.current]);
    return {
        pullRight: internalPullRight,
        dropup: internalDropup,
    };
};
exports.useDropDirection = useDropDirection;
